import { plainToClass } from "class-transformer";
import { UserAffiliationSelctor } from "../../../../secure/list-management/scripts/special-case-sections/UserAffiliationSelection";
import { JsonItem, AppUserExtended, AppUserAffiliation } from "../../../../secure/list-management/scripts/list-management.objects";

declare var $: any;
export class AffiliationsPage {
    affiliationSelector: UserAffiliationSelctor;
    currentAppUserExtended: AppUserExtended;
    pickLists: JsonItem[];


    constructor(entity: any, pickLists: any) {
        $(() => {
            this.currentAppUserExtended = plainToClass(AppUserExtended, <AppUserExtended>entity);
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickLists);
            this.affiliationSelector = new UserAffiliationSelctor("manage-user-affiliation", "AppUserAffiliationList", "pl-member-roles", ["pl-center", "pl-all-cores", "pl-all-projects"], "", false);

            let selectorHtml = this.affiliationSelector.generateHtml();
            $("#affiliation-manager-section").empty().html(selectorHtml);
            this.affiliationSelector.initialize(this.pickLists, [this.currentAppUserExtended]);
            this.affiliationSelector.updateStoredValues([this.currentAppUserExtended]);
        });
    }

    async updateAffiliations(): Promise<any> {
        // Show Saving
        let successModal = $("#success-modal");
        successModal.find("#saving-content").removeClass("d-none");
        successModal.find("#success-content").addClass("d-none");
        successModal.find(".modal-header").addClass("d-none");
        successModal.modal("show");

        let result = await this.saveAffiliations();

        // Show Saved
        successModal.find("#saving-content").addClass("d-none");
        successModal.find("#success-content").removeClass("d-none");
        successModal.find(".modal-header").removeClass("d-none");  
    }

    async saveAffiliations(): Promise<any> {
        let updatedAffiliations: AppUserAffiliation[] = this.affiliationSelector.getValue();
        this.currentAppUserExtended.AppUserAffiliationList = updatedAffiliations;
        let updatedUsers: AppUserExtended[] = [this.currentAppUserExtended];

        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/auth/pages/profile/affiliations?handler=SaveAffiliations`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(updatedUsers) },
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}